function FindTheSeverity(severity) {
    if (severity === 4) return "Super Critical";
    else if (severity === 3) return "Critical";
    else if (severity === 2) return "High";
    else if (severity === 1) return "Low";
    else return "No Alerts";
  }
export default FindTheSeverity